import {
  TRoute,
  TVehicle,
  TRouteAssignment,
  TDriver,
} from 'src/apis/administration/administration.interfaces';
import { mockDocument } from '../documents/documentMock';
import { TTransactionCurrency } from 'src/apis/finance/finance.interfaces';

export const mockDrivers: TDriver[] = [
  {
    id: 'driver-001',
    name: 'Rajesh Kumar',
    licenseNumber: 'KA-01-2020-1234567',
    licenseType: 'PSV',
    licenseExpiryDate: new Date('2025-12-31'),
    phoneNumber: '+91-98765-43210',
    email: 'rajesh.kumar@email.com',
    address: 'Vijayanagar 4th Stage, Bangalore',
    emergencyContact: 'Lakshmi Kumar',
    emergencyContactPhone: '+91-98765-43211',
    joiningDate: new Date('2020-06-01'),
    salary: 25000,
    salaryStatus: 'PAID',
    lastSalaryPaidDate: new Date('2024-01-31'),
    nextSalaryDueDate: new Date('2024-02-28'),
    isActive: true,
    experience: 8,
    medicalCertificateExpiryDate: new Date('2024-12-31'),
    policeVerificationStatus: 'VERIFIED',
    assignedVehicleId: 'vehicle-001',
    assignedRouteId: 'route-001',
  },
  {
    id: 'driver-002',
    name: 'Suresh Reddy',
    licenseNumber: 'KA-01-2019-9876543',
    licenseType: 'PSV',
    licenseExpiryDate: new Date('2024-11-30'),
    phoneNumber: '+91-98765-43212',
    email: 'suresh.reddy@email.com',
    address: 'JP Nagar 7th Phase, Bangalore',
    emergencyContact: 'Padma Reddy',
    emergencyContactPhone: '+91-98765-43213',
    joiningDate: new Date('2019-03-15'),
    salary: 28000,
    salaryStatus: 'PENDING',
    lastSalaryPaidDate: new Date('2024-01-31'),
    nextSalaryDueDate: new Date('2024-02-28'),
    isActive: true,
    experience: 10,
    medicalCertificateExpiryDate: new Date('2024-08-31'),
    policeVerificationStatus: 'VERIFIED',
    assignedVehicleId: 'vehicle-002',
    assignedRouteId: 'route-002',
  },
  {
    id: 'driver-003',
    name: 'Mohan Singh',
    licenseNumber: 'KA-01-2021-4567890',
    licenseType: 'PSV',
    licenseExpiryDate: new Date('2026-03-31'),
    phoneNumber: '+91-98765-43214',
    email: 'mohan.singh@email.com',
    address: 'Marathahalli, Bangalore',
    emergencyContact: 'Kavita Singh',
    emergencyContactPhone: '+91-98765-43215',
    joiningDate: new Date('2021-08-01'),
    salary: 22000,
    salaryStatus: 'OVERDUE',
    lastSalaryPaidDate: new Date('2024-01-31'),
    nextSalaryDueDate: new Date('2024-02-28'),
    isActive: true,
    experience: 6,
    medicalCertificateExpiryDate: new Date('2024-10-31'),
    policeVerificationStatus: 'VERIFIED',
    assignedVehicleId: 'vehicle-003',
    assignedRouteId: 'route-003',
  },
  {
    id: 'driver-004',
    name: 'Venkatesh Iyer',
    licenseNumber: 'KA-01-2018-7890123',
    licenseType: 'PSV',
    licenseExpiryDate: new Date('2024-09-30'),
    phoneNumber: '+91-98765-43216',
    email: 'venkatesh.iyer@email.com',
    address: 'Whitefield, Bangalore',
    emergencyContact: 'Geetha Iyer',
    emergencyContactPhone: '+91-98765-43217',
    joiningDate: new Date('2018-12-01'),
    salary: 30000,
    salaryStatus: 'PAID',
    lastSalaryPaidDate: new Date('2024-01-31'),
    nextSalaryDueDate: new Date('2024-02-28'),
    isActive: false,
    experience: 12,
    medicalCertificateExpiryDate: new Date('2024-07-31'),
    policeVerificationStatus: 'VERIFIED',
    assignedVehicleId: 'vehicle-004',
    assignedRouteId: '',
  },
];

export const mockRoutes: TRoute[] = [
  {
    id: 'route-001',
    routeName: 'Mysore Road Route',
    startLocation: 'School Campus',
    endLocation: 'Mysore Road Junction',
    stops: [
      {
        id: 'stop-001',
        stopName: 'Vijayanagar Bus Stop',
        location: 'Vijayanagar 4th Stage',
        pickupTime: '07:15',
        dropTime: '14:30',
        students: ['student-001', 'student-002', 'student-003'],
        coordinates: { latitude: 12.9716, longitude: 77.5946 },
      },
      {
        id: 'stop-002',
        stopName: 'Kengeri Railway Station',
        location: 'Kengeri',
        pickupTime: '07:25',
        dropTime: '14:20',
        students: ['student-004', 'student-005'],
        coordinates: { latitude: 12.9067, longitude: 77.4853 },
      },
      {
        id: 'stop-003',
        stopName: 'Bidadi Circle',
        location: 'Bidadi',
        pickupTime: '07:35',
        dropTime: '14:10',
        students: ['student-006', 'student-007', 'student-008'],
        coordinates: { latitude: 12.8, longitude: 77.4 },
      },
    ],
    estimatedDuration: 45,
    distance: 25,
    isActive: true,
    assignedVehicleId: 'vehicle-001',
    assignedDriverId: 'driver-001',
    morningPickupTime: '07:00',
    afternoonDropTime: '14:00',
  },
  {
    id: 'route-002',
    routeName: 'Electronic City Route',
    startLocation: 'School Campus',
    endLocation: 'Electronic City Phase 1',
    stops: [
      {
        id: 'stop-004',
        stopName: 'JP Nagar 7th Phase',
        location: 'JP Nagar',
        pickupTime: '07:10',
        dropTime: '14:35',
        students: ['student-009', 'student-010'],
        coordinates: { latitude: 12.9067, longitude: 77.4853 },
      },
      {
        id: 'stop-005',
        stopName: 'Bannerghatta Road',
        location: 'Bannerghatta',
        pickupTime: '07:20',
        dropTime: '14:25',
        students: ['student-011', 'student-012', 'student-013'],
        coordinates: { latitude: 12.8, longitude: 77.4 },
      },
      {
        id: 'stop-006',
        stopName: 'Hosur Road Junction',
        location: 'Hosur Road',
        pickupTime: '07:30',
        dropTime: '14:15',
        students: ['student-014', 'student-015'],
        coordinates: { latitude: 12.9716, longitude: 77.5946 },
      },
    ],
    estimatedDuration: 40,
    distance: 22,
    isActive: true,
    assignedVehicleId: 'vehicle-002',
    assignedDriverId: 'driver-002',
    morningPickupTime: '07:00',
    afternoonDropTime: '14:00',
  },
  {
    id: 'route-003',
    routeName: 'Whitefield Route',
    startLocation: 'School Campus',
    endLocation: 'Whitefield Main Road',
    stops: [
      {
        id: 'stop-007',
        stopName: 'Marathahalli Bridge',
        location: 'Marathahalli',
        pickupTime: '07:05',
        dropTime: '14:40',
        students: ['student-016', 'student-017'],
        coordinates: { latitude: 12.9067, longitude: 77.4853 },
      },
      {
        id: 'stop-008',
        stopName: 'Kundalahalli Gate',
        location: 'Kundalahalli',
        pickupTime: '07:15',
        dropTime: '14:30',
        students: ['student-018', 'student-019', 'student-020'],
        coordinates: { latitude: 12.8, longitude: 77.4 },
      },
      {
        id: 'stop-009',
        stopName: 'ITPL Junction',
        location: 'ITPL',
        pickupTime: '07:25',
        dropTime: '14:20',
        students: ['student-021', 'student-022'],
        coordinates: { latitude: 12.9716, longitude: 77.5946 },
      },
    ],
    estimatedDuration: 50,
    distance: 28,
    isActive: true,
    assignedVehicleId: 'vehicle-003',
    assignedDriverId: 'driver-003',
    morningPickupTime: '07:00',
    afternoonDropTime: '14:00',
  },
];

export const mockVehicles: TVehicle[] = [
  {
    id: 'vehicle-001',
    vehicleNumber: 'KA-01-AB-1234',
    vehicleType: 'BUS',
    capacity: 45,
    driverId: 'driver-001',
    routeId: 'route-001',
    isActive: true,
    lastMaintenanceDate: new Date('2024-01-15'),
    nextMaintenanceDate: new Date('2024-04-15'),
    fuelType: 'DIESEL',
    registrationNumber: 'KA-01-AB-1234',
    insuranceExpiryDate: new Date('2024-12-31'),
    permitExpiryDate: new Date('2025-06-30'),
    pricePerKilometer: 10,
    priceCurrency: TTransactionCurrency.INR,
    vehicleBrand: 'Toyota',
    vehicleModel: 'Fortuner',
    vehicleYear: 2024,
    vehicleColor: 'Red',
    vehicleEngine: '2.5L',
    vehicleTransmission: 'Automatic',
    vehicleFuel: 'Petrol',
    vehicleMileage: 10,
    vehicleImage: [
      mockDocument,
    ],
  },
  {
    id: 'vehicle-002',
    vehicleNumber: 'KA-01-CD-5678',
    vehicleType: 'BUS',
    capacity: 35,
    driverId: 'driver-002',
    routeId: 'route-002',
    isActive: true,
    lastMaintenanceDate: new Date('2024-02-01'),
    nextMaintenanceDate: new Date('2024-05-01'),
    fuelType: 'DIESEL',
    registrationNumber: 'KA-01-CD-5678',
    insuranceExpiryDate: new Date('2024-11-30'),
    permitExpiryDate: new Date('2025-05-31'),
    pricePerKilometer: 10,
    priceCurrency: TTransactionCurrency.INR,
    vehicleBrand: 'Toyota',
    vehicleModel: 'Fortuner',
    vehicleYear: 2024,
    vehicleColor: 'Red',
    vehicleEngine: '2.5L',
    vehicleTransmission: 'Automatic',
    vehicleFuel: 'Petrol',
    vehicleMileage: 10,
    vehicleImage: [
      mockDocument,
    ],
  },
  {
    id: 'vehicle-003',
    vehicleNumber: 'KA-01-EF-9012',
    vehicleType: 'BUS',
    capacity: 40,
    driverId: 'driver-003',
    routeId: 'route-003',
    isActive: true,
    lastMaintenanceDate: new Date('2024-01-30'),
    nextMaintenanceDate: new Date('2024-04-30'),
    fuelType: 'DIESEL',
    registrationNumber: 'KA-01-EF-9012',
    insuranceExpiryDate: new Date('2024-10-31'),
    permitExpiryDate: new Date('2025-04-30'),
    pricePerKilometer: 10,
    priceCurrency: TTransactionCurrency.INR,
    vehicleBrand: 'Toyota',
    vehicleModel: 'Fortuner',
    vehicleYear: 2024,
    vehicleColor: 'Red',
    vehicleEngine: '2.5L',
    vehicleTransmission: 'Automatic',
    vehicleFuel: 'Petrol',
    vehicleMileage: 10,
    vehicleImage: [
      mockDocument,
    ],
  },
  {
    id: 'vehicle-004',
    vehicleNumber: 'KA-01-GH-3456',
    vehicleType: 'VAN',
    capacity: 15,
    driverId: 'driver-004',
    routeId: '',
    isActive: false,
    lastMaintenanceDate: new Date('2024-01-10'),
    nextMaintenanceDate: new Date('2024-04-10'),
    fuelType: 'PETROL',
    registrationNumber: 'KA-01-GH-3456',
    insuranceExpiryDate: new Date('2024-09-30'),
    permitExpiryDate: new Date('2025-03-31'),
    pricePerKilometer: 11,
    priceCurrency: TTransactionCurrency.INR,
    vehicleBrand: 'Toyota',
    vehicleModel: 'Fortuner',
    vehicleYear: 2024,
    vehicleColor: 'Red',
    vehicleEngine: '2.5L',
    vehicleTransmission: 'Automatic',
    vehicleFuel: 'Petrol',
    vehicleMileage: 10,
    vehicleImage: [
      mockDocument,
    ],
  },
];

export const mockStudents = [
  { id: 'student-001', name: 'Arjun Kumar', grade: '10', section: 'A' },
  { id: 'student-002', name: 'Priya Sharma', grade: '9', section: 'B' },
  { id: 'student-003', name: 'Rahul Singh', grade: '11', section: 'A' },
  { id: 'student-004', name: 'Anjali Patel', grade: '8', section: 'C' },
  { id: 'student-005', name: 'Vikram Reddy', grade: '10', section: 'B' },
  { id: 'student-006', name: 'Meera Iyer', grade: '9', section: 'A' },
  { id: 'student-007', name: 'Aditya Verma', grade: '12', section: 'A' },
  { id: 'student-008', name: 'Zara Khan', grade: '8', section: 'B' },
  { id: 'student-009', name: 'Krishna Rao', grade: '10', section: 'C' },
  { id: 'student-010', name: 'Sneha Gupta', grade: '11', section: 'B' },
  { id: 'student-011', name: 'Rohan Malhotra', grade: '9', section: 'C' },
  { id: 'student-012', name: 'Ishita Joshi', grade: '12', section: 'B' },
  { id: 'student-013', name: 'Aryan Kapoor', grade: '8', section: 'A' },
  { id: 'student-014', name: 'Diya Choudhury', grade: '10', section: 'A' },
  { id: 'student-015', name: 'Shaurya Saxena', grade: '11', section: 'C' },
  { id: 'student-016', name: 'Ananya Desai', grade: '9', section: 'B' },
  { id: 'student-017', name: 'Vivaan Mehta', grade: '12', section: 'A' },
  { id: 'student-018', name: 'Kiara Nair', grade: '8', section: 'C' },
  { id: 'student-019', name: 'Dhruv Menon', grade: '10', section: 'B' },
  { id: 'student-020', name: 'Aisha Pillai', grade: '11', section: 'A' },
  { id: 'student-021', name: 'Advait Iyengar', grade: '9', section: 'C' },
  { id: 'student-022', name: 'Mira Sundaram', grade: '12', section: 'B' },
];

export const mockRouteAssignments: TRouteAssignment[] = [
  {
    id: 'assignment-001',
    routeId: 'route-001',
    vehicleId: 'vehicle-001',
    driverId: 'driver-001',
    assignedStudents: [
      'student-001',
      'student-002',
      'student-003',
      'student-004',
      'student-005',
      'student-006',
      'student-007',
      'student-008',
    ],
    academicYear: '2024-2025',
    isActive: true,
    startDate: new Date('2024-06-01'),
    endDate: new Date('2025-03-31'),
  },
  {
    id: 'assignment-002',
    routeId: 'route-002',
    vehicleId: 'vehicle-002',
    driverId: 'driver-002',
    assignedStudents: [
      'student-009',
      'student-010',
      'student-011',
      'student-012',
      'student-013',
      'student-014',
      'student-015',
    ],
    academicYear: '2024-2025',
    isActive: true,
    startDate: new Date('2024-06-01'),
    endDate: new Date('2025-03-31'),
  },
  {
    id: 'assignment-003',
    routeId: 'route-003',
    vehicleId: 'vehicle-003',
    driverId: 'driver-003',
    assignedStudents: [
      'student-016',
      'student-017',
      'student-018',
      'student-019',
      'student-020',
      'student-021',
      'student-022',
    ],
    academicYear: '2024-2025',
    isActive: true,
    startDate: new Date('2024-06-01'),
    endDate: new Date('2025-03-31'),
  },
];
